module.exports = __webpack_public_path__ + "static/media/cloud01.75c3674d.svg";